(function () {
  const modal = document.getElementById('search');
  if (!modal) return;

  const form = modal.querySelector('form');
  const input = document.getElementById('ft-search-input');
  const results = document.getElementById('ft-search-results');
  const status = results.querySelector('.ft-search__status');
  const columns = results.querySelector('.ft-search__columns');
  const secondary = results.querySelector('.ft-search__secondary');
  const primary = results.querySelector('.ft-search__primary');
  const allLink = results.querySelector('.ft-search__all');
  const triggers = () => document.querySelectorAll('#search-toggle, #search-toggle-mobile');
  const enabled = form.dataset.predictiveEnabled === 'true';
  const productLimit = Math.max(2, Math.min(6, Number(form.dataset.productLimit) || 4));
  let timer;
  let controller;
  let version = 0;
  let activeTrigger;
  let previousOverflow;

  function searchUrl(term) {
    const url = new URL(form.action);
    url.searchParams.set('q', term);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.href;
  }

  function internalUrl(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.href : null;
    } catch (error) {
      return null;
    }
  }

  function cancel() {
    clearTimeout(timer);
    if (controller) controller.abort();
    controller = null;
    version += 1;
  }

  function clearResults() {
    secondary.replaceChildren();
    primary.replaceChildren();
    status.textContent = '';
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }

  function showState(message, term) {
    secondary.replaceChildren();
    primary.replaceChildren();
    columns.hidden = true;
    status.textContent = message;
    allLink.href = searchUrl(term);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function close(restoreFocus) {
    if (modal.hidden) return;
    cancel();
    clearResults();
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
    triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (restoreFocus && activeTrigger && activeTrigger.isConnected) activeTrigger.focus();
    activeTrigger = null;
  }

  function open(trigger) {
    if (modal.parentElement !== document.body) document.body.append(modal);
    activeTrigger = trigger;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;
    triggers().forEach((item) => item.setAttribute('aria-expanded', 'true'));
    input.focus({ preventScroll: true });
    schedule();
  }

  function group(title, items, getLink, isProduct) {
    const validItems = items.map((item) => ({ item, href: getLink(item) })).filter(({ href }) => href);
    if (!validItems.length) return null;

    const section = document.createElement('section');
    section.className = 'ft-search__group';
    const heading = document.createElement('h3');
    heading.className = 'ft-search__group-title';
    heading.textContent = title;
    section.append(heading);
    const list = document.createElement('ul');
    list.className = 'ft-search__list';

    validItems.forEach(({ item, href }) => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'ft-search__result-link';
      link.href = href;

      if (isProduct) {
        const thumbnail = document.createElement('span');
        thumbnail.className = 'ft-search__thumbnail';
        if (item.image) {
          try {
            const imageUrl = new URL(item.image, window.location.origin);
            if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
              imageUrl.searchParams.set('width', '144');
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = '';
              image.width = 72;
              image.height = 72;
              image.loading = 'lazy';
              thumbnail.append(image);
            }
          } catch (error) {
            thumbnail.replaceChildren();
          }
        }
        link.append(thumbnail);
      }

      const label = document.createElement('span');
      label.textContent = isProduct ? item.title : item.text || item.title;
      link.append(label);
      li.append(link);
      list.append(li);
    });

    section.append(list);
    return section;
  }

  function render(data, term) {
    const found = data && data.resources && data.resources.results;
    if (!found) throw new Error('Invalid predictive search response');

    secondary.replaceChildren();
    primary.replaceChildren();
    let count = 0;
    const add = (target, section) => {
      if (!section) return;
      count += section.querySelectorAll('li').length;
      target.append(section);
    };

    if (form.dataset.showQueries === 'true') {
      add(secondary, group(form.dataset.queries, (found.queries || []).slice(0, 2),
        (item) => item.text ? searchUrl(item.text) : null));
    }
    if (form.dataset.showPages === 'true') {
      add(secondary, group(form.dataset.pages, (found.pages || []).slice(0, 2),
        (item) => internalUrl(item.url)));
    }
    if (form.dataset.showCollections === 'true') {
      add(secondary, group(form.dataset.collections, (found.collections || []).slice(0, 2),
        (item) => internalUrl(item.url)));
    }
    add(primary, group(form.dataset.products, (found.products || []).slice(0, productLimit),
      (item) => internalUrl(item.url), true));

    secondary.hidden = !secondary.childElementCount;
    primary.hidden = !primary.childElementCount;
    columns.hidden = count === 0;
    columns.classList.toggle('ft-search__columns--single', !secondary.childElementCount || !primary.childElementCount);
    status.textContent = count === 1 ? form.dataset.countOne :
      count ? form.dataset.count.replace('__COUNT__', count) : form.dataset.empty;
    allLink.href = searchUrl(term);
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function schedule() {
    cancel();
    clearResults();
    if (!enabled || modal.hidden) return;

    const term = input.value.trim();
    if (!term) return;
    showState(form.dataset.loading, term);
    const currentVersion = version;

    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(form.dataset.predictiveUrl, window.location.origin);
      const types = ['product'];
      if (form.dataset.showQueries === 'true') types.push('query');
      if (form.dataset.showPages === 'true') types.push('page');
      if (form.dataset.showCollections === 'true') types.push('collection');
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', types.join(','));
      url.searchParams.set('resources[limit]', productLimit);
      url.searchParams.set('resources[limit_scope]', 'each');

      try {
        const response = await fetch(url.href, { signal: controller.signal });
        if (!response.ok) throw new Error('Predictive search unavailable');
        const data = await response.json();
        if (currentVersion === version && !modal.hidden && input.value.trim() === term) render(data, term);
      } catch (error) {
        if (currentVersion === version && !modal.hidden && input.value.trim() === term) {
          showState(form.dataset.error, term);
        }
      }
    }, 200);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('#search-toggle, #search-toggle-mobile');
    if (trigger) {
      event.preventDefault();
      if (modal.hidden) open(trigger);
      else close(true);
      return;
    }

    if (modal.hidden) return;
    if (event.target === modal || event.target.closest('.ft-search__close')) {
      close(true);
    } else if (event.target.closest('.icon-menu, .cart-button')) {
      close(false);
    }
  }, true);

  input.addEventListener('input', (event) => {
    if (event.isComposing) {
      cancel();
      clearResults();
      return;
    }
    schedule();
  });
  input.addEventListener('compositionend', schedule);

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close(true);
      return;
    }

    const focusable = Array.from(modal.querySelectorAll('button, input:not([type="hidden"]), a[href]'))
      .filter((element) => element.getClientRects().length && !element.closest('[hidden]'));
    if (event.key === 'Tab' && focusable.length) {
      if (event.shiftKey && document.activeElement === focusable[0]) {
        event.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
        event.preventDefault();
        focusable[0].focus();
      }
      return;
    }

    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    const links = Array.from(results.querySelectorAll('a[href]'));
    if (results.hidden || !links.length) return;
    const index = links.indexOf(document.activeElement);
    if (document.activeElement === input && event.key === 'ArrowDown') {
      event.preventDefault();
      links[0].focus();
    } else if (index >= 0) {
      event.preventDefault();
      if (event.key === 'ArrowUp' && index === 0) input.focus();
      else links[Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
    }
  });
})();
